import { getCS } from "../model/carsubs";

export const setBooking = (booking) => {
	return {
		type: "SET_BOOKING_CS",
		payload: booking,
	};
};

export const getCSDetail = (ex) => {
	return {
		type: "GET_CS_DETAIL",
		payload: getCS(ex),
	};
};
